
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("wgY32", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c41ef9cbeebda23f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $c41ef9cbeebda23f$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "P\xe1gina sin t\xedtulo",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "Crea una nueva p\xe1gina e ins\xe9rtala como enlace",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "Crear p\xe1gina de Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Abrir en Confluence',
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "Se ha creado tu p\xe1gina",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "P\xe1gina creada",
    'editorExtensionLinkCreate.confluencePage.title': "Crear p\xe1gina nueva",
    'editorExtensionLinkCreate.genericError.description': "Actualiza la p\xe1gina y vuelve a intentarlo.",
    'editorExtensionLinkCreate.genericError.title': 'Se ha producido un error',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "Crea una incidencia en l\xednea e ins\xe9rtala como enlace",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Crear incidencia de Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Abrir en Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Se ha creado tu incidencia',
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Incidencia creada',
    'editorExtensionLinkCreate.jiraIssue.title': 'Crear nueva incidencia',
    'editorExtensionLinkCreate.keyword.create': 'crear',
    'editorExtensionLinkCreate.keyword.issue': 'incidencia',
    'editorExtensionLinkCreate.keyword.new': 'nuevo',
    'editorExtensionLinkCreate.keyword.page': "p\xe1gina",
    'editorExtensionLinkCreate.keyword.publish': 'publicar',
    'editorExtensionLinkCreate.keyword.raise': 'generar',
    'editorExtensionLinkCreate.keyword.space': 'espacio',
    'editorExtensionLinkCreate.keyword.ticket': 'ticket'
};

});


//# sourceMappingURL=es.76ecfe38.js.map
